import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {ReactComponent as AddSvg} from './../assets/icons/svg/add.svg';
import {ReactComponent as BerandaSvg} from './../assets/icons/svg/beranda.svg';
import {ReactComponent as BeritaSvg} from './../assets/icons/svg/berita.svg';
import {ReactComponent as CartSvg} from './../assets/icons/svg/cart.svg';
import {ReactComponent as MitraSvg} from './../assets/icons/svg/mitra.svg';
import transaction from "../actions/transaction";


export default function Layout({children, active, bg}) {
   const [cart, setCart] = useState(0);
   const navigate = useNavigate();
   const menu = [
      {id: 1, name: 'Beranda', path: '/home', icon: <BerandaSvg/>},
      {id: 2, name: 'Mitra', path: '/partner', icon: <MitraSvg/>},
      {id: 3, name: 'Add', path: '/trash', icon: <AddSvg/>},
      {id: 3, name: 'Berita', path: '/news', icon: <BeritaSvg/>},
      {id: 4, name: 'Keranjang', path: '/cart', icon: <CartSvg/>},
   ]

   useEffect(()=>{
      if(sessionStorage.getItem('token') && sessionStorage.getItem('token').length>0){
         transaction.actions.get_cart().then((res)=>{
            setCart(res?.trash_deposit_items.length)
         });
      } else {
         navigate('/')
      }
   },[])

   const handleClick = (urls) => {
      navigate(urls);
   };
   return (
      <div className={"min-vh-100 " + (bg ? bg : "bg-white")}>
         {children}
         <div className="navigate-mobile">
            {
               menu.map((item,key)=>{
                  return (
                     <div 
                        key={key} 
                        className={
                           item.name === 'Add' ?
                           ('navigate-mobile-add') :
                           ('navigate-mobile-item ' + (active == item.id ? 'active' : ''))
                        } 
                        onClick={() => handleClick(item.path)}
                     >
                        <div className={"nbi-icon " + ((item.name === 'Keranjang' && cart > 0) ? 'notify':'')}>
                           {item.icon}
                        </div>
                        { item.name !== 'Add' ?
                           <div className="nbi-text">{item.name}</div> : 
                           null
                        }
                     </div>
                  )
               })
            }
         </div>
      </div>
   );
}